import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import { colorFormatter } from "../../fomatters/ColorFormatter";
import { createColorEditor } from "../../editors/ColorEditor";

/**
 * TABLE SYSTEMCOLORS
 */
function PlayerRating() {
  return (
    <Crud
      title="Player Rating"
      getUrl={() => "/Player/PlayerRate_GetList"}
      // INSERT
      insertUrl={() => "/Player/PlayerRate_Insert"}
      insertParams={({ userId }, { playerRateName }) => ({
        PlayerRateName: playerRateName,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/PlayerRate_Update"}
      updateParams={({ userId }, { idPlayerRate, playerRateName }) => ({
        IdPlayerRate: idPlayerRate,
        PlayerRateName: playerRateName,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/PlayerRate_Delete"}
      deleteParams={({ userId }, id) => ({
        IdPlayerRate: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idPlayerRate"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="playerRateName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Name
      </TableHeaderColumn>
    </Crud>
  );
}

export default PlayerRating;
